module.exports = __webpack_public_path__ + "img/1.73c05ede.png";